import { Component } from "@angular/core";
import {Async} from "@helper/async.decorator";
import {Subject} from "rxjs";

@Component({
	selector: "app-refund-payment-succes-cancel-popup",
	templateUrl: "./refund-payment-succes-cancel-popup.component.html",
	styleUrls: ["./refund-payment-succes-cancel-popup.component.scss"]
})
export class RefundPaymentSuccesCancelPopupComponent {
	@Async() public close$ = new Subject<boolean>();
}
